import React, { useState } from "react";
import styles from "./SignUp.module.css";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, styled, ThemeProvider } from "@mui/material/styles";
import logo from "../../Assets/logo.webp";
import Parse from "../../API/ParseServer";
import { useNavigate } from "react-router-dom";

function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="/">
        Faam Gallery
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();
const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#863a18",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#863a18",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#863a18",
    },
    "&:hover fieldset": {
      borderColor: "#863a18",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#863a18",
    },
  },
});
export default function SignUp() {
  const [errorMessage, setErrorMessage] = useState("");
  const validEmail =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const validMobile =
    /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;
  function validatePassword(pw: any) {
    return (
      /[A-Z]/.test(pw) &&
      /[a-z]/.test(pw) &&
      /[0-9]/.test(pw) &&
      /[^A-Za-z0-9]/.test(pw) &&
      pw.length > 4
    );
  }
  const navigate = useNavigate();
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    console.log(process.env.PARSE_APP_ID);
    const email = data.get("email");
    const password = data.get("password");
    const confirmPassword = data.get("confirm-password");
    const firstName = data.get("firstName");
    const lastName = data.get("lastName");
    const phoneNumber = data.get("phone-number");

    if (
      email &&
      firstName &&
      lastName &&
      password &&
      phoneNumber &&
      confirmPassword
    ) {
      if (!validEmail.test(String(email))) {
        setErrorMessage("Invalid email address");
      } else if (!validMobile.test(String(phoneNumber))) {
        setErrorMessage("Invalid phone number");
      } else if (!validatePassword(password))
        setErrorMessage(
          "Paint your password with 8+ strokes and at least one special symbol (e.g.,!@#$%^&*)",
        );
      else if (!(confirmPassword === password)) {
        setErrorMessage(
          "Uh-oh! Your passwords are clashing like clashing colours. Try again!",
        );
      } else {
        setErrorMessage("");
        const user = new Parse.User();
        user.set("username", email);
        user.set("password", password);
        user.set("email", email);
        user.set("lastName", lastName);
        user.set("firstName", firstName);
        user.set("phoneNumber", Number(phoneNumber));
        try {
          await user.signUp();
          if (localStorage.getItem("guestId")) {
            const prevBasket = await Parse.Cloud.run("getBasket", {
              user: user.id,
            });
            const newBasket = await Parse.Cloud.run("getBasket", {
              user: localStorage.getItem("guestId"),
            });
            if (prevBasket && newBasket.get("items")) {
              newBasket.get("items").forEach(async (item: any) => {
                const response = await Parse.Cloud.run("addToBasket", {
                  user: user.id,
                  artworkId: item.artwork
                    ? item.artwork.id
                    : item.userArtwork
                      ? item.userArtwork.id
                      : "",
                  quantity: item.quantity,
                  frameId: item.frame ? item.frame.id : "",
                  specifications: item.specifications,
                  type: item.type,
                  itemId: "",
                });
              });
              newBasket.destroy();
            } else if (newBasket.get("items")) {
              await Parse.Cloud.run("loginBasket", {
                user: user.id,
                guestId: localStorage.getItem("guestId"),
              });
            }
            localStorage.removeItem("guestId");
          }
          navigate("/");
        } catch (error: any) {
          console.log(`Error: ${error.message}`);
          setErrorMessage(error.message);
        }
      }
    } else {
      setErrorMessage("Please fill in your information completely");
    }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container
        component="main"
        maxWidth="xs"
        sx={{ height: "calc(100vh - 6rem)" }}
      >
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Link href="/">
            <img src={logo} alt="Faam Gallery" className={styles.logo} />
          </Link>{" "}
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{ mt: 3 }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <CssTextField
                  autoComplete="given-name"
                  name="firstName"
                  required
                  fullWidth
                  id="firstName"
                  label="First Name"
                  autoFocus
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CssTextField
                  required
                  fullWidth
                  id="lastName"
                  label="Last Name"
                  name="lastName"
                  autoComplete="family-name"
                />
              </Grid>
              <Grid item xs={12}>
                <CssTextField
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                />
              </Grid>
              <Grid item xs={12}>
                <CssTextField
                  required
                  fullWidth
                  id="phone-number"
                  label="Phone Number"
                  name="phone-number"
                  autoComplete="phone-number"
                />
              </Grid>
              <Grid item xs={12}>
                <CssTextField
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="new-password"
                />
              </Grid>
              <Grid item xs={12}>
                <CssTextField
                  required
                  fullWidth
                  name="confirm-password"
                  label="Confirm Password"
                  type="password"
                  id="confirm-password"
                />
              </Grid>
              {/* <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox value="allowExtraEmails" color="primary" />
                  }
                  label="I want to receive inspiration, marketing promotions and updates via email."
                />
              </Grid> */}
            </Grid>
            <button className={styles.button} type="submit">
              Sign Up
            </button>
            <br />
            <br />
            {errorMessage && (
              <Typography
                sx={{
                  textAlign: "center",
                  my: 2,
                  color: "#862e18",
                  fontWeight: "bold",
                }}
              >
                {errorMessage}
              </Typography>
            )}
            <Grid container justifyContent="center">
              <Grid item>
                <Link href="/login" variant="body2" color={"#863a18"}>
                  Already have an account? Sign in
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>
  );
}
